/**
 * Hero pause button
 */

const hero_pause_button = (args) => {
    // setup args
    let buttons = args.buttons;

    // validate
    if (!buttons.length) {
        // console.log('Invalid hero pause button args');
        return;
    }

    function init() {
        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                // console.log('Pause button clicked');

                let text = button.querySelector('.js-hero-pause-button-text');

                if (!text) {
                    return;
                }

                // Find all videos in this hero
                let hero = button.closest('.hero');
                let videos = hero.querySelectorAll(
                    '.js-hero-pause-button-media'
                );

                if (!videos.length) {
                    // console.log('... Video not found');
                    // console.log('hero', hero);
                    // console.log('videos', videos);
                    return;
                }

                videos.forEach((video) => {
                    if (video.paused) {
                        video.play();
                        text.innerText = button.getAttribute('data-text-pause');
                        button.classList.remove('-paused');
                        button.classList.add('-playing');
                    } else {
                        video.pause();
                        text.innerText = button.getAttribute('data-text-play');
                        button.classList.remove('-playing');
                        button.classList.add('-paused');
                    }
                });
            });
        });
    }

    init();

    // make the call chainable
    return this;
};

hero_pause_button({
    buttons: document.querySelectorAll('.js-hero-pause-button'),
});
